import { render, staticRenderFns } from "./UserGrantList.vue?vue&type=template&id=13ac4696&scoped=true"
import script from "./UserGrantList.vue?vue&type=script&lang=js"
export * from "./UserGrantList.vue?vue&type=script&lang=js"
import style0 from "./UserGrantList.vue?vue&type=style&index=0&id=13ac4696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac4696",
  null
  
)

export default component.exports